import axiosClient from "@/utils/axios-client";
import { FavoriteBrandsResponse } from "@/shared/api/favorite-brands/types";
import { favoriteBrandsUrl } from "@/shared/api/favorite-brands/url";

export const favoriteBrandsQueryApi = {
  // 바이어의 즐겨찾기 브랜드 조회
  getFavoriteBrands: async (buyerId: number) => {
    const { data } = await axiosClient.get<FavoriteBrandsResponse>(
      favoriteBrandsUrl.root(buyerId)
    );
    return data;
  },
};
